import { Component } from "react";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("Respondia UI error", error, info?.componentStack); }
  componentDidUpdate(prev) { if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null }); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-[50vh] grid place-items-center p-6" data-testid="error-boundary">
        <div className="max-w-md text-center space-y-3">
          <AlertTriangle className="w-8 h-8 text-amber-500 mx-auto" />
          <h2 className="font-heading font-semibold text-lg">Un affichage n'a pas pu être chargé</h2>
          <p className="text-sm text-slate-500">Une donnée manquante a empêché l'affichage de cette page. Le reste de Respondia continue de fonctionner.</p>
          <div className="flex gap-2 justify-center">
            <button onClick={() => this.setState({ error: null })} className="h-10 px-4 rounded-xl bg-slate-900 text-white text-sm" data-testid="error-boundary-retry">Réessayer</button>
            <a href="/app/dashboard" className="h-10 px-4 rounded-xl border border-slate-200 text-sm inline-flex items-center" data-testid="error-boundary-home">Tableau de bord</a>
          </div>
        </div>
      </div>
    );
  }
}
